module.exports = "/virtual-football-league/img/amblems/right/logos/Lille.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Lille.png
// module id = 2210
// module chunks = 4